export enum Semaphore {
    Blank = 0,
    Red = 1,
    Yellow = 2,
    Green = 3,
    Static = 4,
    Rising = 5,
    Falling = 6
  };